import { render, staticRenderFns } from "./KeyboardShortcuts.vue?vue&type=template&id=4a988a3c&scoped=true"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=js"
import style0 from "./KeyboardShortcuts.vue?vue&type=style&index=0&id=4a988a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a988a3c",
  null
  
)

export default component.exports